import { render, staticRenderFns } from "./DepartmentManagementDepartmentsModal.vue?vue&type=template&id=1c9a5c3b"
import script from "./DepartmentManagementDepartmentsModal.vue?vue&type=script&lang=js"
export * from "./DepartmentManagementDepartmentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports